module.exports = __webpack_public_path__ + "img/u-newphone.69d97f9a.jpg";